/* Author: Derrick Pelletier
 * CenterLoader and RunCenter are used to load product images in various situations locations and center them to the parent, then fade it. Supports cropping and not-cropping.
*/

$(function() {
    var selectCallback = function(variant, selector) {
    if (variant && variant.available == true) {
      // selected a valid variant
      jQuery('#purchase').removeClass('disabled').removeAttr('disabled'); // remove unavailable class from add-to-cart button, and re-enable button
      jQuery('#price-field').html(Shopify.formatMoney(variant.price, ""));  // update price field
    } else {
      // variant doesn't exist
      jQuery('#purchase').addClass('disabled').attr('disabled', 'disabled');      // set add-to-cart button to unavailable class and disable button
      var message = variant ? "Sold Out" : "Unavailable";    
      jQuery('#price-field').text(message); // update price-field message
    }
  }
});

IE9 = (navigator.appVersion.indexOf("MSIE 9.")==-1) ? false : true;
function centerLoader(targ, crop)
{
	$(targ).attr("loaded","false");
	if(IE9 == true) {
		var osrc = $(targ).attr("src");
		$(targ).attr('src', osrc.substring(0, osrc.lastIndexOf('?')));
	}
	$(targ).parent().imagesLoaded( function(){
		runCenter(targ,crop);
	});	
}
function runCenter(targ, crop){
	if($(targ).attr("loaded") == "true") return;
	$(targ).attr("loaded","true");
	
	if($(targ).innerWidth() == 0) {
	} else {
		var w = $(targ).parent().innerWidth();
		var h = $(targ).parent().innerHeight();
		var r = w/h;
		if( crop ) {
			if($(targ).innerWidth()/$(targ).innerHeight() > r) {
				$(targ).attr("height", h);
				if($(targ).css("position") != "absolute") {
					$(targ).css("margin-left", ($(targ).parent().width()/2 - $(targ).width()/2) + "px");
				} else {
					$(targ).css("left", "50%");
					$(targ).css("margin-left", "-" + $(targ).width()/2 + "px");
				}
			} else {
				$(targ).attr("width", w);
				if($(targ).css("position") != "absolute") {
					$(targ).css("margin-top", ($(targ).parent().height()/2 - $(targ).height()/2) + "px");
				} else {
					$(targ).css("top", "50%");
					$(targ).css("margin-top", "-" + $(targ).height()/2 + "px");
				}
			}
		} else {
			if($(targ).innerWidth()/$(targ).innerHeight() > r) {
				$(targ).attr("width", w);
				$(targ).css("top", "50%");
				$(targ).css("left","0px");
				$(targ).css("margin-top", "-" + $(targ).height()/2 + "px");
			} else {
				$(targ).attr("height", h);
				$(targ).css("left", "50%");
				$(targ).css("top", "0px");	
				$(targ).css("margin-left", "-" + $(targ).width()/2 + "px");
			}
		}
	}
	$(targ).fadeTo("fast",1);
}


$(document).ready(function(){
	
	

	    $(".slideshow-enabled #featured .cropper").slides({
            container: 'slideshow',
            crossfade: 'true',
            effect: 'fade',
            generatePagination: false,
            preload: true,
            preloadImage: '//cdn.shopify.com/s/files/1/0188/7164/t/29/assets/base-ajax-loader.gif?v=1365936092',
            play: 5000
        });

	
	
	
	
	$(".product_small .product_image img").each(function(){centerLoader(this, false);});
	$(".related img, #product-photos ul img, .cart_item .cropper img, .search_results .result img").each(function(){centerLoader(this, true);});
	
	// SHARING BUTTON
	$(".sharing .newbutton").click(function(){
		var $b = $(this).parent().find(".share_box:first");
		if($b.hasClass("active")) {
			$b.removeClass("active").stop().clearQueue().animate({"opacity":0, "left":95},"fast",function(){$b.hide()});
		} else {
			var w = 7 + 5 + 7 + $(".twitter-share-button:first").outerWidth() + $b.find(".facebook-like-button").outerWidth();
			if($b.outerWidth() < 223) $b.css("width", 223);//.css("margin-left", -Math.round(w/2));
			$b.addClass("active").css("opacity",0).css("left",95).show().animate({"opacity":1, "left":105},"fast");
		}
		return false;
	});
	
	// SELECT BOXES STYLING
	$("select.uniform").uniform();
	$("select.loc_on_change").change(function(){
		if($(this).attr("value") == "#") return false;
		window.location = $(this).attr("value");
	});
	
	
	$("#about_module").each(function(){
		var min = 320;
		var con_height = $(this).find("#am_content .inner:first").outerHeight();
		var extra_height = $(this).find("#new_items").outerHeight();
		if(con_height + extra_height >= min) return;
		$(this).find("#am_content .inner:first").css("height", min-extra_height+"px");
	});
	
	// Manipulation of Nav Dropdowns
	$(".navdrop").each(function(x) {
		var drop = this;
		var first = false;
		if( $(drop).parent().hasClass("first")) first = true;
		$(drop).parent().hover(function(){
			$(this).addClass("hover");
			$(drop).show();
			if(!$(drop).hasClass("split")) {
				var tab_width = $(drop).parent().find("a:first").innerWidth()-15;
				if(first) {
					tab_width += 20;
					$(drop).css("margin-left", "-13px");
				}
				$(drop).find(".tab, .tabshadow").css("width", tab_width + "px");
				var ul_left = $(drop).find(".navdrop_container ul.left:first");
				var ul_right = $(drop).find("ul.right:first");
				var size = $(ul_left).find("li").length;
				var left_height = $(ul_left).outerHeight();
				var right_height = 0;
				
				if(size == 1) {
					$(drop).find(".navdrop_container").addClass("single");
				}
				
				while(right_height <= left_height && size > 1) {
					$(ul_right).prepend($(ul_left).find("li:last").detach());
					right_height = $(ul_right).outerHeight();
					left_height = $(ul_left).outerHeight();
				}
				if(right_height > left_height) {
					$(ul_left).append($(ul_right).find("li:first").detach());
				}	
				$(ul_left).find("li:last").addClass("last");
				$(ul_right).find("li:last").addClass("last");
				
				console.log(Math.max( (tab_width + 20), $(drop).outerWidth()));
				
				$(drop).addClass("split");
				var container = $(drop).find(".navdrop_container:first");
				if($(container).outerWidth() <= tab_width) {
					$(container).css("width", tab_width-40).addClass("no_top_right");
				}
				
				
				
			}
		},
		function(){
			$(this).removeClass("hover");
			$(drop).hide();
		});
		
	});
	
	$("#product_table tr").each(function(n) {
		$(this).find(".product_small .content_match").equalHeightColumns();
	});
	$("#q, #mce-EMAIL").makeFadingPlaceHolder();
	$("#product-photos").makeProductImages($("#photo-frame-bottom .cropper:first"));
    $('.fancy').fancybox();
	$('.scrollpane').jScrollPane({verticalGutter: 10});
});

jQuery(function(){
	var targs = new Array();
	if($(".homerow").get(0)) {
		targs.push($(".homerow").eq(0).find(".product_small .content_match"));
		targs.push($(".homerow").eq(1).find(".product_small .content_match"));
		targs.push($(".homerow").eq(2).find(".product_small .content_match"));
		for (x in targs) {
			targs[x].equalHeightColumns()
		}
	}
});
$.fn.makeProductImages = function(imgs)
{
	return this.each(function() {
		var $this = $(this);
		var $imgs = $(imgs);
		var current_image = 0;
		if( img_data.length <= 1 ) return;
		$active = $imgs.find("a:first");
		var waiting = false;
		$this.find("ul li a").each(function(n){
			$(this).attr('data-index',n);
			$(this).click(function(){
				if(waiting) return false;
				waiting = true;
				$this.find("ul li.active").removeClass("active");
				$(this).parent().addClass("active");
				showNewImage(n);
				return false;
			});
		});
		function showNewImage(n) {
			$imgs.css("height", $active.outerHeight());
			$active.fadeOut("fast",function(){
				loadImage(n);
			});
		}
		function loadImage(n) {
			if( img_data[n].loaded ) {
				
				showImage(n);
			} else {
				$("#photo-frame-bottom .cropper").addClass("loading");
				$imgs.append('<a href="" id="product-img-'+n+'"><img src=""  class="product-photo-large" /></a>');
				var html = $("#product-img-"+n).hide();
				$(html).find("img:first").load(function(){
					img_data[n].loaded = true;
					$("#photo-frame-bottom .cropper").removeClass("loading");
					showImage(n);
				});
				$imgs.addClass("loading");
				$(html).attr("href", img_data[n].src);
               $(html).find("img:first").attr("src", img_data[n].src);
			}
            $('.cropper').children('a').addClass("fancy");
            $('.cropper').children('.fancy').fancybox();
		}
		function showImage(n) {
           $active.removeClass("active");
			$active = $("#product-img-"+n);
			$active.css("position","absolute");
			$imgs.animate({height:$active.outerHeight()},"fast",function(){
				$imgs.removeClass("loading");
				if( $active.outerWidth() < 296 ) {
					$active.css({"left":"50%","margin-left":-($active.outerWidth()/2)+"px"});
				}
				 $("#product-img-"+n).fadeIn("normal", function(){	
					waiting=false;
				}).addClass("active");	
			});
			
			
			
		}
		
		
	});	
}
$.fn.makeFadingPlaceHolder = function()
{
	return this.each(function() {
		var $this = $(this);
		var $ph = $("#" + $this.attr("id") + "_placeholder");
		$this.focus(function(){
			$ph.fadeOut("fast");
		});
		$this.blur(function(){
			if($this.val() == "") {
				$ph.fadeIn("fast");
			}
		});
		$ph.click(function(){
			$this.focus();
		});
	});
	
};

